(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["protection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function animateCounter(el) {
      if (el.dataset.animated === 'true') return;
      el.dataset.animated = 'true';

      var valueEl = el.querySelector('.ph-stat__value');
      if (!valueEl) return;

      var raw = (el.dataset.target || '').toString().trim();
      var duration = parseInt(el.dataset.duration, 10) || 2000;

      // Detect "k" multiplier and decimals
      var hasK = /k/i.test(raw);
      var numericPart = raw.replace(/[^0-9.]/g, '');
      var target = parseFloat(numericPart);

      if (isNaN(target)) {
        valueEl.textContent = raw;
        return;
      }

      var isDecimal = numericPart.indexOf('.') !== -1;
      var decimals = isDecimal ? (numericPart.split('.')[1] || '').length : 0;

      // Respect reduced-motion preference
      var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced) {
        valueEl.textContent = formatValue(target, decimals, hasK);
        return;
      }

      var start = null;
      var startValue = 0;

      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }

      function formatValue(val, decimals, hasK) {
        if (hasK) {
          // Format like "28k"
          return Math.round(val).toString() + 'k';
        }
        if (decimals > 0) {
          return val.toFixed(decimals);
        }
        return Math.round(val).toString();
      }

      function step(timestamp) {
        if (!start) start = timestamp;
        var elapsed = timestamp - start;
        var progress = Math.min(elapsed / duration, 1);
        var eased = easeOutCubic(progress);
        var current = startValue + (target - startValue) * eased;

        valueEl.textContent = formatValue(current, decimals, hasK);

        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          valueEl.textContent = formatValue(target, decimals, hasK);
        }
      }

      window.requestAnimationFrame(step);
    }

    function init(root) {
      var stats = root.querySelectorAll('[data-stat]');
      if (!stats.length) return;

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              animateCounter(entry.target);
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.35 });

        stats.forEach(function (s) { io.observe(s); });
      } else {
        // Fallback: animate immediately
        stats.forEach(animateCounter);
      }
    }

    function boot() {
      document.querySelectorAll('.ph-section').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    // Shopify theme editor support
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.ph-section');
      if (section) init(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
